export default __webpack_public_path__ + "static/media/icon-next.2c8bbeec.svg";